import AdminServices from './container';

export default AdminServices;
